import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap"
import { useLocation, useParams, withRouter, Link } from "react-router-dom"
import profile from "../../assets/images/profile-img.png"
import logo from "../../assets/images/logo.svg"
import * as Yup from "yup"
import { useFormik } from "formik"
import {
  resetErrorMessage,
  userResetPassword,
  resetDonwMessage,
} from "store/actions"
import { useSelector, useDispatch } from "react-redux"
import { FaEye, FaEyeSlash } from "react-icons/fa"

const ResetPasswordPage = props => {
  const location = useLocation()
  // const { email } = location.state

  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [successMessage, setSuccessMessage] = useState(null)
  const [errorLocalMessage, setErrorLocalMessage] = useState(null)
  const [sendPass, setSendPass] = useState(null)

  const { token } = useParams()

  if (!token) {
    return <div>Token inválido ou expirado.</div>
  }

  const errorMessage = useSelector(state => state.ResetPassword.errorMessage)
  const resetPass = useSelector(state => state.ResetPassword.reset)

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword)
  }

  const dispatch = useDispatch()

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      // email: email,
      password: "",
      confirmPassword: "",
    },

    validationSchema: Yup.object({
      password: Yup.string()
        .required("Por favor informe sua senha")
        .min(6, "A senha deve ter pelo menos 6 caracteres")
        .matches(/[a-zA-Z]/, "A senha deve conter pelo menos uma letra")
        .matches(
          /[!@#$%^&*(),.?":{}|<>]/,
          "A senha deve conter pelo menos um caractere especial"
        )
        .test(
          "senha-sequencia-repetida",
          "A senha não pode conter sequências de números ou letras",
          value => {
            const sequentialChars =
              "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
            for (let i = 0; i < sequentialChars.length - 2; i++) {
              const sequence = sequentialChars.slice(i, i + 3)
              if (
                value == "" ||
                value == undefined ||
                value == null ||
                value.includes(sequence) ||
                value.includes(sequence.split("").reverse().join(""))
              ) {
                return false
              }
            }
            return true
          }
        )
        .test(
          "senha-sequencia-repetida",
          "A senha não pode conter três caracteres iguais em sequência",
          value => {
            if (value == "" || value == undefined || value == null) {
              return false
            } else {
              for (let i = 0; i < value.length - 2; i++) {
                if (value[i] === value[i + 1] && value[i] === value[i + 2]) {
                  return false
                }
              }
              return true
            }
          }
        ),

      confirmPassword: Yup.string()
        .required("O campo de Confirme sua senha é obrigatório")
        .oneOf([Yup.ref("password"), null], "As senhas devem ser iguais"),
    }),
    onSubmit: values => {
      setSendPass(true)
      dispatch(userResetPassword({ ...values, token }, props.history))
      validation.resetForm()
    },
  })

  useEffect(() => {
    dispatch(resetDonwMessage())
  }, [])

  useEffect(() => {
    dispatch(resetErrorMessage())
  }, [dispatch])

  useEffect(() => {
    if (sendPass) {
      if (errorMessage) {
        setErrorLocalMessage(errorMessage)
        setSuccessMessage(null)
      } else if (resetPass) {
        setErrorLocalMessage(null)
        setSuccessMessage("Senha atualizada com sucesso!")
      }
    }
  }, [errorMessage, resetPass, sendPass])

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft bg-soft-primary">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Seja bem vindo!</h5>
                        <p className="text-primary">
                          Antes de iniciar, redefina sua senha!
                        </p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {(successMessage || errorLocalMessage) && (
                      <Alert color={successMessage ? "success" : "danger"}>
                        {successMessage || errorLocalMessage}
                      </Alert>
                    )}
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">Senha</Label>
                        <div className="input-group">
                          <Input
                            id="password"
                            name="password"
                            type={showPassword ? "text" : "password"}
                            placeholder="Inserir sua senha"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          <button
                            className="btn btn-secondary rounded-end"
                            type="button"
                            onClick={togglePasswordVisibility}
                          >
                            {showPassword ? (
                              <FaEyeSlash size={15} />
                            ) : (
                              <FaEye size={15} />
                            )}
                          </button>
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Confirmar senha</Label>

                        <div className="input-group">
                          <Input
                            name="confirmPassword"
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Inserir novamente sua senha"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.confirmPassword || ""}
                            invalid={
                              validation.touched.confirmPassword &&
                              validation.errors.confirmPassword
                                ? true
                                : false
                            }
                          />
                          <button
                            className="btn btn-secondary rounded-end"
                            type="button"
                            onClick={toggleConfirmPasswordVisibility}
                          >
                            {showConfirmPassword ? (
                              <FaEyeSlash size={15} />
                            ) : (
                              <FaEye size={15} />
                            )}
                          </button>
                          {validation.touched.confirmPassword &&
                          validation.errors.confirmPassword ? (
                            <FormFeedback type="invalid">
                              {validation.errors.confirmPassword}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>

                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md "
                            type="submit"
                            disabled={
                              !(
                                validation.isValid &&
                                validation.dirty &&
                                validation.values.password !== "" &&
                                validation.values.confirmPassword !== ""
                              ) || successMessage
                            }
                          >
                            Redefinir
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} Leads Plataform. Desenvolvido com{" "}
                  <i className="mdi mdi-heart text-danger" /> por MRP Solution
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ResetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ResetPasswordPage)
